import { mapState } from "vuex";
import { checkLanguage } from "@/service/user";
import QRCode from "qrcode";
import { getWxLoginUrl, uuidCheck } from "../../service/wx";
import { getServerConfigBoolean } from "@/service/server";
export default {
  data() {
    return {
      value: "",
      interval: null,
      stale: false,
      activeStatus: "UN_SCAN",
      status: {
        UN_SCAN: "",
        SCANED_LOGIN: $t("c2zpinb", "已扫码 请点击确认登录"),
        SCANED_REGIST: $t("o7d296c", "已扫码 请绑定后确认登录"),
        SCAN_CONFIRM: $t("iw7lg39", "扫码确认 正在登录"),
        SCAN_CANCEL: $t("pudln65", "扫码已取消"),
        UN_BIND_OPENID: $t("w4cg4xb", "请在手机上填写绑定信息")
      }
    };
  },
  props: ["check"],
  destroyed() {
    this.clear();
  },
  computed: {
    ...mapState({
      language: state => state.app.language
    }),
    SCAN_EWM() {
      return getServerConfigBoolean("VUE_APP_SCAN_EWM", true);
    },
    icon_check() {
      return this.activeStatus !== "SCAN_CANCEL" ? "ios-checkmark-circle" : this.activeStatus === "SCAN_CANCEL" ? "ios-alert" : "";
    }
  },
  methods: {
    clear() {
      this.stale = true;
      clearInterval(this.interval);
      this.interval = null;
      setTimeout(() => {
        this.activeStatus = "UN_SCAN";
      }, 0);
    },
    refresh() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      return this.getQRCode();
    },
    async getQRCode(noCheck) {
      this.stale = false;
      const res = await getWxLoginUrl();
      const {
        qrCode,
        uuid
      } = res.data.retVal;
      console.log("res", qrCode);
      await checkLanguage(uuid, this.language);
      QRCode.toCanvas(document.getElementById("qrcode_canvas"), qrCode, {
        width: 200
      });
      if (!noCheck) {
        this.uuidCheckIterval(uuid);
      }
      return uuid;
    },
    uuidCheckIterval(uuid) {
      // 如果微信登录，不需要执行
      if (localStorage.getItem("wxLogin") === "T") {
        return;
      }
      this.interval = setInterval(async () => {
        const res = await uuidCheck(uuid);
        if (res.data && res.data.result == 0) {
          const {
            status,
            expire
          } = res.data.retVal;
          if (expire <= 0) {
            this.clear();
          } else {
            this.activeStatus = status;
          }
          if (status === "SCAN_CONFIRM") {
            this.login(res.data);
          }
          if (status === "SCAN_CANCEL" || expire === 0) {
            this.$emit("logout");
          }
        }
      }, 3000);
    },
    // 将扫码确认结果传给登录页，在选单位前处理移动端 destination。
    login(loginResult) {
      this.$nextTick(() => {
        this.$store.commit("setLogin", true);
        this.$emit("login", loginResult);
      });
    }
  },
  mounted() {
    if (!this.SCAN_EWM) {
      this.status.UN_SCAN = $t("shh6hf8", "暂不支持扫码登录");
    }
    if (this.check) {
      this.getQRCode();
    }
  }
};